import { AnimatePresence } from "motion/react";
import { AchievementCelebration } from "./AchievementCelebration";
import { MinimalBlockCelebration } from "./MinimalBlockCelebration";
import type { ActiveCelebration } from "./celebration.types";

type CelebrationHostProps = {
  celebration: ActiveCelebration | null;
  onDismiss: () => void;
  shouldReduceMotion: boolean;
};

export function CelebrationHost({
  celebration,
  onDismiss,
  shouldReduceMotion,
}: CelebrationHostProps) {
  return (
    <AnimatePresence mode="wait">
      {celebration?.type === "block-generated" ? (
        <MinimalBlockCelebration
          key={celebration.id}
          celebration={celebration}
          onDismiss={onDismiss}
          shouldReduceMotion={shouldReduceMotion}
        />
      ) : null}
      {celebration?.type === "achievement-unlocked" ? (
        <AchievementCelebration
          key={celebration.id}
          celebration={celebration}
          onDismiss={onDismiss}
          shouldReduceMotion={shouldReduceMotion}
        />
      ) : null}
    </AnimatePresence>
  );
}
